if (!customElements.get('related-products-tabs')) {
  class RelatedProductsTabs extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
    }

    connectedCallback() {
      this.parentUrl = this.dataset.parentUrl;
      const section = this.closest('.section--related-products');
      if (!section) return;

      this.tabs = Array.from(section.querySelectorAll('.related-products__tab'));
      this.grids = Array.from(this.querySelectorAll('.related-products__grid[data-tab]'));
      this.seeMoreLink = section.querySelector('[data-tabs-see-more]');

      if (!this.tabs.length) return;
      this.tabs.forEach(tab => tab.addEventListener('click', this.handleTabClick));
    }

    disconnectedCallback() {
      this.tabs.forEach(tab => tab.removeEventListener('click', this.handleTabClick));
    }

    handleTabClick(event) {
      const tab = event.currentTarget;
      const isAlreadyActive = tab.classList.contains('is-active');

      if (isAlreadyActive) {
        this.tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        this.grids.forEach(grid => {
          grid.hidden = grid.dataset.tab !== 'parent';
        });

        if (this.seeMoreLink) {
          this.seeMoreLink.href = this.parentUrl;
        }
      } else {
        const targetKey = tab.dataset.tab;

        this.tabs.forEach(t => {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });

        this.grids.forEach(grid => {
          grid.hidden = grid.dataset.tab !== targetKey;
        });

        if (this.seeMoreLink) {
          this.seeMoreLink.href = tab.dataset.collectionUrl;
        }
      }
    }
  }

  customElements.define('related-products-tabs', RelatedProductsTabs);
}
